module.exports = __webpack_public_path__ + "images/3aceec1a23056bd1d37727ec7b2066af7dd4c2276e1e5f8b28d9ef3af49cd220.svg";